export function ListItemNotes({ form, setForm, products }) {
  const byId = Object.fromEntries(products.map((p) => [p.id, p]));
  const notes = form.item_notes || {};
  const set = (id, key, val) => setForm({ ...form, item_notes: { ...notes, [id]: { ...(notes[id] || {}), [key]: val } } });
  if (!form.product_ids.length) return null;
  return (
    <div data-testid="list-item-notes">
      <label className="block text-xs font-medium text-[#5C5A56] mb-1.5">Roundup labels & verdicts (optional — empty labels are filled automatically)</label>
      <div className="space-y-2">
        {form.product_ids.map((id, i) => (
          <div key={id} className="border border-[#E5E0D8] rounded-lg p-3">
            <p className="text-sm font-medium text-[#2C2B29] mb-2">{i + 1}. {byId[id]?.title || id}</p>
            <div className="grid sm:grid-cols-[12rem_1fr] gap-2">
              <input data-testid={`list-note-bestfor-${i}`} placeholder="Best for… e.g. Small families" value={notes[id]?.best_for || ""} onChange={(e) => set(id, "best_for", e.target.value)} className="px-2.5 py-2 rounded border border-[#E5E0D8] text-xs" />
              <input data-testid={`list-note-verdict-${i}`} placeholder="One-line verdict" value={notes[id]?.verdict || ""} onChange={(e) => set(id, "verdict", e.target.value)} className="px-2.5 py-2 rounded border border-[#E5E0D8] text-xs" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
